import React, { useMemo } from 'react';
import block from 'bem-cn';

import top1WEBP from './img/top1.webp';
import top2WEBP from './img/top2.webp';
import top3WEBP from './img/top3.webp';

import './NetentTournamentItem.scss';

const b = block('netent-tournament-item-desktop');

const positions = {
  top1: top1WEBP,
  top2: top2WEBP,
  top3: top3WEBP,
};

const NetentTournamentItem = ({ item }) => {
  const position = useMemo(() => {
    if (item.position <= 7) {
      return positions.top1;
    } else if (item.position <= 9) {
      return positions.top2;
    } else {
      return positions.top3;
    }
  }, [item]);

  return (
    <div className={b()}>
      <img className={b('position')} src={position} alt="" />
      <div className={b('col')}>
        <span className={b('text')}>{item.position}</span>
        <div className={b('divider')} />
      </div>
      <div className={b('col')}>
        <span className={b('text')}>{item.username}</span>
        <div className={b('divider')} />
      </div>
      <div className={b('col')}>
        <span className={b('points')}>{item.points}</span>
      </div>
    </div>
  );
};

export default NetentTournamentItem;
